<script setup lang="ts">
import {computed, ref} from "vue";
import {useRules} from "vuetify/labs/rules";

const rules = useRules()

const form = ref<HTMLFormElement>()
const comment = ref<string>('');
const valid = ref<boolean>(false);
const emit = defineEmits<{ submit: [string] }>();

const isDisabled = computed(() => comment.value.length === 0);

const submitAndClear = async () => {
    const {valid} = await form.value?.validate()

    if (!valid) {
        return;
    }

    emit('submit', comment.value);
    comment.value = '';

    form.value?.resetValidation();
}
</script>

<template>
    <v-form
        ref="form"
        v-model="valid"
        class="pa-0 ma-0"
        @submit.prevent="submitAndClear"
    >
        <v-textarea
            v-model="comment"
            rows="1"
            placeholder="Write a comment..."
            :rules="[rules.required(), rules.pattern(/^(?!\s*$).+/), rules.maxLength(1000)]"
            :hide-details="valid"
            auto-grow
        />
        <v-btn
            variant="flat"
            class="mt-2 px-4"
            :disabled="isDisabled"
            type="submit"
        >
            Comment
        </v-btn>
    </v-form>
</template>

<style scoped>

</style>
